/*
 * Broadcast Theme
 *
 * Custom Javascript for Hunky Chunky. Loaded from layout/theme.liquid with defer,
 * so it runs after the document is parsed and cannot block rendering.
 */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
   * Add to cart button price
   *
   * Broadcast renders the button price server side from current_variant.price
   * and refreshes it only on variant change, so it ignores quantity and knows
   * nothing about the subscription widget, which is a Shopify app block the
   * theme cannot see. The widget also sits OUTSIDE the product form, as its own
   * block above the buttons, so everything here is scoped to the section.
   *
   * What the markup actually looks like, confirmed by reading the rendered DOM
   * rather than assuming:
   *
   *   - The widget renders a COMPLETE set of purchase option radios for EVERY
   *     variant at once. Eight flavours times four options is thirty two radios
   *     in the page, of which only one group is visible. Taking "the first
   *     checked radio with a price" therefore always found Sunday Cookie's row
   *     and the button never moved off $32.00.
   *   - Each group's radio name ends with its variant id, which is the only
   *     reliable way to pick the visible group.
   *   - Every radio's value is the string "on", so values identify nothing.
   *   - selling_plan is present as a hidden field but is not a usable signal
   *     for which option is selected.
   *
   * So: find the radio group whose name carries the current variant id, take
   * the checked one, and read the price from its own row. One time shows the
   * full price, a subscription shows the discounted one, so there is no
   * discount arithmetic here that could drift from what Shopify charges.
   *
   * Principle throughout: if anything cannot be read with confidence, leave the
   * server rendered price alone. A stale price is recoverable. A wrong price in
   * a button labelled "Add to cart" is not.
   * -------------------------------------------------------------------- */

  var MONEY = /([0-9][0-9,]*)\.([0-9]{2})/g;

  function moneyIn(text) {
    if (!text) return [];
    MONEY.lastIndex = 0;
    var out = [], m;
    while ((m = MONEY.exec(text)) !== null) {
      out.push(parseInt(m[1].replace(/,/g, ''), 10) * 100 + parseInt(m[2], 10));
    }
    return out;
  }

  function formatMoney(cents) {
    cents = Math.abs(Math.round(cents));
    var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var part = String(cents % 100);
    if (part.length < 2) part = '0' + part;
    return '$' + whole + '.' + part;
  }

  /* Walk up from a radio until we reach an ancestor holding exactly one price.
     Exactly one matters: stop too high and the ancestor holds every option's
     price, and the first of those is not the selected one. */
  function rowPrice(input) {
    var node = input;
    for (var i = 0; i < 6 && node; i++) {
      var found = moneyIn(node.textContent);
      if (found.length === 1) return found[0];
      if (found.length > 1) return null;
      node = node.parentElement;
    }
    return null;
  }

  function currentVariantId(form) {
    var f = form.querySelector('.product-variant-id') || form.querySelector('[name="id"]');
    return f && f.value ? String(f.value) : null;
  }

  /* Price of the option the customer has actually selected, for the variant
     they are actually looking at. */
  function selectedUnitPrice(scope, form) {
    var vid = currentVariantId(form);
    var checked = scope.querySelectorAll('input[type="radio"]:checked');
    var fallback = null;
    for (var i = 0; i < checked.length; i++) {
      var r = checked[i];
      var price = rowPrice(r);
      if (price === null) continue;
      if (vid && r.name && r.name.indexOf(vid) !== -1) return price;
      if (fallback === null) fallback = price;
    }
    /* Only trust the fallback when there is no variant to match against, such
       as a product with a single default variant. */
    return vid ? null : fallback;
  }

  function syncButtonPrice(scope, form) {
    try {
      var target = form.querySelector('[data-product-price]');
      if (!target) return;
      if (target.querySelector('s')) return;   /* compare at price, leave alone */

      /* Server rendered price, captured per variant so a flavour priced
         differently later stays correct. */
      var variant = currentVariantId(form) || 'single';
      if (target.dataset.hcVariant !== variant) {
        var base = moneyIn(target.textContent);
        if (base.length !== 1) return;
        target.dataset.hcVariant = variant;
        target.dataset.hcBase = String(base[0]);
      }

      var qtyInput = form.querySelector('[data-quantity-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      var unit = selectedUnitPrice(scope, form);
      if (unit === null) unit = parseInt(target.dataset.hcBase, 10);

      target.textContent = formatMoney(unit * qty);
    } catch (e) {
      /* Leave whatever the server rendered. */
    }
  }

  function watch(form) {
    if (form.dataset.hcPriceWatched) return;
    form.dataset.hcPriceWatched = 'true';

    var scope = form.closest('.shopify-section') || document.body;

    var pending = null;
    function schedule() {
      if (pending) cancelAnimationFrame(pending);
      pending = requestAnimationFrame(function () {
        pending = null;
        syncButtonPrice(scope, form);
      });
    }

    scope.addEventListener('change', schedule);
    scope.addEventListener('input', schedule);
    scope.addEventListener('click', schedule);

    if (window.MutationObserver) {
      var mo = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          if (t && t.hasAttribute && t.hasAttribute('data-product-price')) continue;
          schedule();
          return;
        }
      });
      mo.observe(scope, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['value', 'checked', 'class']
      });
    }

    schedule();
  }

  function init() {
    var forms = document.querySelectorAll('form[data-product-form]');
    for (var i = 0; i < forms.length; i++) watch(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('quickview:loaded', init);
})();
